<template>
    <div>
        <el-row :gutter="20" style="height: 60vh" class="echarts">
            <el-col :span="12" style="height: 100%">
                <IEcharts theme='shine' :option="genomeSizeOptions" :resizable="true" v-if="genomeSizeOptions !== null" />
            </el-col>
            <el-col :span="12" style="height: 100%">
                <IEcharts theme='shine' :option="repeatDensityOptions" :resizable="true" v-if="repeatDensityOptions !== null" />
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { homeSizevsSSRDensity } from '../scripts/Euk_GenomeSize_Percent.js';
import IEcharts from 'vue-echarts-v3/src/full.js';
import prepareBoxplotData from 'echarts/extension/dataTool/prepareBoxplotData.js';
import { store } from '../scripts/store.js';
import { exponentiateBases } from '../scripts/utils';

const yLables = [];
const KEYS = _.range(0,14);
KEYS.forEach((e,i) => {
    yLables.push(homeSizevsSSRDensity[parseInt(i)]['SubGroup'])
});
const titleTextStyle = { fontSize: 20, fontWeight: 'bold', width: '20%', fontFamily: 'Oxygen'}
const quartileInfo = { 
                        text: 'upper: Q3 + 1.5 * IQR \nlower: Q1 - 1.5 * IQR',
                        borderColor: '#999',
                        borderWidth: 1, 
                        textStyle: { fontSize: 10, fontWeight: 'bold' },
                        left: '10',
                        top: '10'
                    };
const toolTipInfo = { trigger: 'item', axisPointer: { type: 'shadow' }};
const yAxisObj = {
                name: 'SubGroup',
                nameLocation: 'middle',
                nameGap: 100,
                margin: 8,
                alignWithLabel: true,
                nameTextStyle: { fontSize: 16,  fontWeight: 'bold',  width: '20%', fontFamily: 'Oxygen' },
                type: 'category',
                axisTick: {  alingWithLabel: true },
                boundaryGap: true,
                data: yLables,
                axisLabel: { 
                    fontWeight: 'bold',
                    fontFamily: 'Oxygen'
                },
                splitArea: { show: true },
                splitLine: { show: false }
            }
let xAxisObj = {  type: 'log', 
                    name: 'Genome Size', 
                    nameLocation: 'middle',
                    nameGap: 25,
                    margin: 8,
                    alignWithLabel: true,
                    nameTextStyle: {
                        fontSize: 16, 
                        fontWeight: 'bold', 
                        width: '20%',
                        fontFamily: 'Oxygen', 
                    },
                axisLabel: { formatter: function(num) { return exponentiateBases(num) }},
}
const gridOptions =  { left: 80, right: 20, bottom: 40, containLabel: true, }


export default {
    name: 'HomeBoxPlot',
    components: { IEcharts },
    computed: {
        genomeSizeOptions: function() {
            const x = _.clone(xAxisObj)
            x.name = 'Genome Size'
            let data = [];
            const labels = [];
            for (let a of KEYS) {
                data.push(homeSizevsSSRDensity[a]['GenomeSize']);
                labels.push(homeSizevsSSRDensity[a]['SubGroup'])
            }
            data = prepareBoxplotData(data, {layout: 'vertical'});
            data.axisData = labels;
          
            
            const option = {
                title: [
                    { 
                        text: 'Genome size ranges in Eukaryotes', 
                        textStyle: titleTextStyle,
                        left: 'center', 
                    },
                    quartileInfo
                ],
                tooltip: toolTipInfo,
                grid: gridOptions,
                yAxis: yAxisObj,
                xAxis: x, 
                series: [
                    {
                        name: 'Genome Size',
                        type: 'boxplot',
                        boxWidth: '30%',
                        itemStyle: { borderColor: '#324517' },
                        data: data.boxData,
                        tooltip: {
                            formatter: function (param) {
                                const info = [
                                    '<b>Group: </b>' + param.name,
                                    '<b>Maximum: </b>' + exponentiateBases(parseInt(param.data[5])),
                                    // '<b>Q3: </b>' + exponentiateBases(parseInt(param.data[4])),
                                    '<b>Median: </b>' + exponentiateBases(parseInt(param.data[3])),
                                    // '<b>Q1: </b>' + exponentiateBases(parseInt(param.data[2])),
                                    '<b>Minimum: </b>' + exponentiateBases(parseInt(param.data[1]))
                                ].join('<br/>');
                                return `<div style="text-align: left">${info}</div>`
                            },
                            backgroundColor: 'rgba(238, 238, 238, 0.8)',
                            textStyle: {
                                color: 'black',
                                fontFamily: 'Oxygen', 
                            },
                        },
                    },
                    {
                        name: 'outlier',
                        type: 'scatter',
                        data: data.outliers,
                        symbolSize: 5,
                        tooltip: {
                            backgroundColor: 'rgba(238, 238, 238, 0.8)',
                            textStyle: { color: 'black' },
                            formatter: function(d) { return `<b>Outlier:</b> ${exponentiateBases(d.data[0])}` }
                        },
                        color: '#324157'
                    }
                ]
            };
            return option
        },
        repeatDensityOptions: function() {
            xAxisObj.name = 'Percentage genome covered by SSRs'
            let data = [];
            const labels = [];
            for (let a of KEYS) {
                data.push(homeSizevsSSRDensity[a]['PercentGenomeCovered']);
                labels.push(homeSizevsSSRDensity[a]['SubGroup'])
            }
            data = prepareBoxplotData(data, {layout: 'vertical'});
            data.axisData = labels;
            
            
            const option = {
                title: [
                    { 
                        text: 'Range of percentage genome covered by SSRs in Eukaryotes', 
                        textStyle: titleTextStyle,
                        left: 'center', 
                    },
                    // quartileInfo
                ],
                tooltip: toolTipInfo,
                grid: gridOptions,
                yAxis: yAxisObj,
                xAxis: xAxisObj,
                series: [
                    {
                        name: 'Genome Size',
                        type: 'boxplot',
                        boxWidth: '30%',
                        itemStyle: { borderColor: '#324517' },
                        data: data.boxData,
                        tooltip: {
                            formatter: function (param) {
                                const info = [
                                    '<b>SubGroup:</b> ' + param.name,
                                    '<b>Maximum: </b>' + param.data[5].toFixed(2),
                                    // '<b>Q3: </b>' + param.data[4].toFixed(2),
                                    '<b>Median: </b>' + param.data[3].toFixed(2),
                                    // '<b>Q1: </b>' + param.data[2].toFixed(2),
                                    '<b>Minimum: </b>' + param.data[1].toFixed(2)
                                ].join('<br/>');
                                return `<div style="text-align: left">${info}</div>`
                            },
                            backgroundColor: 'rgba(238, 238, 238, 0.8)',
                            textStyle: {
                                color: 'black',
                                fontFamily: 'Oxygen', 
                            }
                        },
                    },
                    {
                        name: 'outlier',
                        type: 'scatter',
                        data: data.outliers,
                        symbolSize: 5,
                        tooltip: {
                            backgroundColor: 'rgba(238, 238, 238, 0.8)',
                            textStyle: { color: 'black' },
                            formatter: function(d) { return `<b>Outlier:</b> ${d.data[0]}` }
                        },
                        color: '#324157'
                    }
                ]
            };
            return option
        }
    }
}
</script>
